import { makeStyles } from '@material-ui/core/styles';

import { sideNavWidth } from '../side-nav/SideNavStyles';

const useStyles = makeStyles((theme) => ({
    content: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),

        marginLeft: 0,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),

        marginLeft: sideNavWidth,

        '@media print': {
            marginLeft: 0,
        },
    },
}));

export default useStyles;
